import { defineMessages } from 'react-intl';

const orderStatusMessages = defineMessages({
    orderSuccessTitle: {
        id: 'orderSuccessPage.orderSuccessTitle',
        description: 'Order success title',
        defaultMessage: 'Yay! Successfully sent'
    },
    orderFailureTitle: {
        id: 'orderSuccessPage.orderFailureTitle',
        description: 'Order failure title',
        defaultMessage: 'Sorry, payment failed'
    },
    orderFailureMessage: {
        id: 'orderSuccessPage.orderFailureMessage',
        description: 'Order failure message',
        defaultMessage: 'Don\'t worry, your money is not deducted.'
    },
    orderSuccessMessage: {
        id: 'orderSuccessPage.orderSuccessMessage',
        description: 'Order Success message',
        defaultMessage: 'Congratulations ! Your order is successfully placed and you will receive eGift email in 5 minutes.'
    },
    buyAnotherButtonLabel: {
        id: 'orderSuccessPage.buyAnotherButtonLabel',
        description: 'Buy another button text',
        defaultMessage: 'Buy another gift card'
    },
    tryAgainButtonLabel: {
        id: 'orderSuccessPage.tryAgainButtonLabel',
        description: 'Try again button text',
        defaultMessage: 'Try again'
    },
    cancelButtonLabel: {
        id: 'orderSuccessPage.cancelButtonLabel',
        description: 'Cancel button text',
        defaultMessage: 'Back to home'
    },
    personalMessageLabel: {
        id: 'orderSuccessPage.personalMessageLabel',
        description: 'Personal message label',
        defaultMessage: 'Personal message'
    },
    giftCardValueLabel: {
        id: 'orderSuccessPage.giftCardValueLabel',
        description: 'Gift card value label',
        defaultMessage: 'Value'
    },
    sendToLabel: {
        id: 'orderSuccessPage.snedToLabel',
        description: 'Send to label',
        defaultMessage: 'Send to'
    },
    orderIdLabel: {
        id: 'orderSuccessPage.orderIdLabel',
        description: 'Order id label',
        defaultMessage: 'Order ID'
    },
    amountPaidLabel: {
        id: 'orderSuccessPage.amountPaidLabel',
        description: 'Amount paid label',
        defaultMessage: 'Amount paid'
    },
    howToRedeemLabel: {
        id: 'orderSuccessPage.howToRedeemLabel',
        description: 'How to redeem label',
        defaultMessage: 'How to redeem'
    },
    faqsLabel: {
        id: 'orderSuccessPage.faqsLabel',
        description: 'FAQs label',
        defaultMessage: 'FAQs'
    },
    customerSupportLabel: {
        id: 'orderSuccessPage.customerSupportLabel',
        description: 'Customer support label',
        defaultMessage: 'Customer support'
    },
    amountToPayLabel: {
        id: 'orderSuccessPage.amountToPayLabel',
        description: 'Amount to pay label',
        defaultMessage: 'Amount to pay'
    },
    orderSummaryLabel: {
        id: 'orderSuccessPage.orderSummaryLabel',
        description: 'Order Summary Label',
        defaultMessage: 'Order summary'
    }
});

export default orderStatusMessages;
